<template>
    <el-dialog
        title="修改地址"
        :visible.sync="addressDialogVisible"
        :close-on-click-modal="false"
        width="1000px" class="addressDialog">
        <div class="logisticsDialog">
            <el-form ref="logisticsForm" class="demo-ruleForm">
                <el-scrollbar style="height: 500px">
                    <div class="addressList">
                        <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in addressList" :key="index">
                            <el-checkbox class="checkBox" v-model="item.checked" @change="addressChecked(item)"></el-checkbox>
                            <div class="name">{{item.receiverName}}</div>
                            <div class="tel">{{item.mobile}}</div>
                            <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
                            <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
                        </div>
                    </div>
                </el-scrollbar>
                <el-form-item class="submitButtonGroup">
                    <el-button type="primary" @click="addressSubmit">确定</el-button>
                    <el-button @click="addressDialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import {getAddressList,updateBuyerPrintOrder} from '../../../utils/interface';
    export default {
        name: "editAddress",
        data(){
            return{
                addressDialogVisible:false,
                takeOverUuid:"",
                printOrderUuid:"",
                addressList:"",
            }
        },
        methods: {
            init(printOrderUuid,takeOverUuid){
                getAddressList().then((res)=>{
                    res.data.map(items => {
                        if(takeOverUuid!=''){
                            if(items.uuid == takeOverUuid){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }else{
                            if(items.defaultVal==1){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }
                        /*if(items.uuid == takeOverUuid){
                            items.checked = true;
                            this.takeOverUuid = takeOverUuid
                        }else {
                            items.checked = false
                        }*/
                    });
                    this.addressList = res.data
                })
                this.printOrderUuid = printOrderUuid;
                this.addressDialogVisible = true
            },
            addressSubmit(){
                let params = {
                    uuid:this.printOrderUuid,
                    takeOverUuid:this.takeOverUuid,
                };
                updateBuyerPrintOrder(params).then((res)=>{
                    if(res.success){
                        this.$message.success('地址修改成功！');
                        this.addressDialogVisible = false;
                        this.$emit('editAddressSuccess')
                    }
                });
            },
            addressChecked(val){
                console.log(val)
                this.addressList.map(item=>{
                    if(item.uuid === val.uuid){
                        item.checked = val.checked;
                    } else {
                        item.checked = false
                    }
                });
                this.takeOverUuid = val.uuid;
            },
        }
    }
</script>

<style scoped lang="less">
    .addressDialog{
        /deep/.el-dialog__header{
            border-bottom: 1px solid #ddd;
        }
        /deep/.el-dialog__body{
            padding: 0;
        }
        .submitButtonGroup{
            text-align: right;
            margin-bottom: 0;
            border-top: 1px solid #ddd;
            padding: 10px 30px;
        }
    }
    .addressList{
        padding: 24px 30px 20px;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/editAddress.vue